var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "social-group",
      class: _vm.widget.widgetSettings.socialIconStyle,
    },
    [
      _c(
        "ul",
        { staticClass: "social-list" },
        [
          _vm._l(_vm.widget.socialLinks, function (item, index) {
            return [
              item.url !== "https://" && item.url !== ""
                ? _c(
                    "li",
                    { key: index, staticClass: "social-list-item" },
                    [
                      _c(
                        "generic-link",
                        {
                          staticClass: "social-link",
                          class: item.title,
                          attrs: {
                            href: item.url,
                            title: item.title,
                            target: "_blank",
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "social-icon" },
                            [
                              _c("social-svg-icons", {
                                staticClass: "icon",
                                attrs: { name: item.title },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }